import { FormFragmentFragment } from '../../__generated__/graphql';
import Form from '../../components/Form';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

const FormContentBlock: ContentBlock<FormFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.formContentBlock;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="white"
      id={contentBlockProps.sectionId}
    >
      <Form
        description={contentBlockProps.description}
        disclaimer={contentBlockProps.disclaimer}
        gravityForm={contentBlockProps.gravityForm}
        title={contentBlockProps.title}
      />
    </Section>
  );
};

export default FormContentBlock;
